type WindowClientLike = { visibilityState?: string; focused?: boolean };
type ClientsLike = {
  matchAll: (options: object) => Promise<ReadonlyArray<WindowClientLike>>;
};

export interface WindowClientsDescription extends Record<string, unknown> {
  windowClients: number | 'unavailable' | 'error';
  visibleClients?: number;
  focusedClients?: number;
}

/** How many pages the worker controls and how many of them the user sees, for diagnostics. */
export async function describeWindowClients(): Promise<WindowClientsDescription> {
  const clients = (self as unknown as { clients?: ClientsLike }).clients;
  if (!clients) {
    return { windowClients: 'unavailable' };
  }
  try {
    const list = await clients.matchAll({ type: 'window', includeUncontrolled: true });
    return {
      windowClients: list.length,
      visibleClients: list.filter((client) => client.visibilityState === 'visible').length,
      focusedClients: list.filter((client) => client.focused).length,
    };
  } catch {
    return { windowClients: 'error' };
  }
}
